export default __webpack_public_path__ + "static/media/net_ball_light.8ca2031d.png";